class IntoViewBlock extends HTMLElement {
  constructor() {
    super();

    if (!this.hasAttribute('data-animate')) {
      return;
    }

    this.threshold = parseFloat(this.getAttribute('data-animate')) || 0;

    this.handleIntersection();
  }

  handleIntersection() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.removeAttribute('data-animate');
            observer.disconnect();
          }
        });
      },
      {
        threshold: this.threshold,
      },
    );

    observer.observe(this);
  }
}

customElements.define('into-view-block', IntoViewBlock);
